import ModalFullScreen from "@/components/shared/modalFullscreen";
import {
  useState,
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
} from "react";
import { X } from "lucide-react";
import Image from "next/image";
// import { Copy } from "lucide-react";

type SignInModalProps = {
  showSignInModal: boolean;
  setShowSignInModal: Dispatch<SetStateAction<boolean>>;
  imageUrl: string;
};

const SignInModal = ({
  showSignInModal,
  setShowSignInModal,
  imageUrl,
}: SignInModalProps) => {
  // const pathname = usePathname();
  // const currentUrl = process.env.NEXT_PUBLIC_BASE_URL + pathname; //"?_id=" + _id

  return (
    <ModalFullScreen
      showModal={showSignInModal}
      setShowModal={setShowSignInModal}
    >
      <button onClick={() => setShowSignInModal(false)}>
        <div className="absolute right-0 top-0 z-10">
          <X size={24} color="white" className="mr-2 mt-2" />
        </div>
        <Image
          src={imageUrl}
          alt="image"
          layout="fill"
          objectFit="contain"
          loading="eager"
          unoptimized
        />
      </button>
    </ModalFullScreen>
  );
};

export function useFullScreenModal(imageUrl: any) {
  const [showFullScreenModal, setFullScreenModal] = useState(false);

  const FullScreenModalCallback = useCallback(() => {
    return (
      <SignInModal
        showSignInModal={showFullScreenModal}
        setShowSignInModal={setFullScreenModal}
        imageUrl={imageUrl}
      />
    );
  }, [showFullScreenModal, setFullScreenModal]);

  return useMemo(
    () => ({ setFullScreenModal, FullScreenModal: FullScreenModalCallback }),
    [setFullScreenModal, FullScreenModalCallback],
  );
}
